/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Button, INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export type PickupInfo = {
    name?: string;
    notes?: string;
};

export interface IShowContactInfoInput {
    canEdit: boolean;
    email: string;
    newsletter: boolean;
    pickupInfo: PickupInfo | null;
    resources: {
        editBtnLabel: string;
        newsletterLabel: string;
        pickupNameLabel: string;
        pickupNotesLabel: string;
    };
    onEdit(): void;
}

export interface IShowContactInfo {
    showInfoProps: INodeProps;
    email: React.ReactNode;
    newsletter: React.ReactNode;
    pickupName?: React.ReactNode;
    pickupNotes?: React.ReactNode;
    editButton?: React.ReactNode;
}

const getContactInfo = ({
    canEdit,
    email,
    newsletter,
    pickupInfo,
    resources: { editBtnLabel, newsletterLabel, pickupNameLabel, pickupNotesLabel },
    onEdit
}: IShowContactInfoInput): IShowContactInfo => ({
    showInfoProps: { className: 'ms-checkout-guest-profile__selected-item' },
    email: <span className='ms-checkout-guest-profile__selected-email'>{email}</span>,
    newsletter: (
        <div>
            <span className='hei-checkout-guest-profile__newsletter'>
                <label>
                    <input type='checkbox' checked={newsletter} disabled /> {newsletterLabel}
                </label>
            </span>
        </div>
    ),
    pickupName: pickupInfo?.name && (
        <span className='hei-checkout-guest-profile-section hei-checkout-guest-profile__pickup-name'>
            <label>{pickupNameLabel}</label> {pickupInfo.name}
        </span>
    ),
    pickupNotes: pickupInfo?.notes && (
        <span className='hei-checkout-guest-profile-section hei-checkout-guest-profile__pickup-notes '>
            <label>{pickupNotesLabel}</label> {pickupInfo.notes}
        </span>
    ),
    editButton: canEdit && (
        <Button className='ms-checkout-guest-profile__btn-edit' title={editBtnLabel} color='link' onClick={onEdit}>
            {editBtnLabel}
        </Button>
    )
});

export default getContactInfo;
